import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  ", "\n\n  &:after {\n    content: '';\n    display: block;\n    position: absolute;\n    width: ", ";\n    height: ", ";\n    left: 0;\n    background-color: ", ";\n    ", "\n    ", "\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n\n  ", "\n  ", "\n  \n  &:before {\n    content: '\u201C';\n    display: block;\n    color: ", ";\n    position: absolute;\n    top: 0;\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n  }\n\n  ", " + ", " {\n    ", "\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import styled from 'styled-components';
import { Quote } from '../../Typography';
import { EMPTY_PROPS, getPx } from '../../helpers';
import { ADVENTURE_GREEN, NIGHTINGALE_BLACK } from '../../colors';
import { largeHeadingStyle } from '../../Typography/style/large-heading';
import { userSelectNoneStyle } from '../../tokens/user-select';
import { bottom, fontSize, left, lineHeight, marginBottom, marginTop, paddingLeft, paddingTop } from '../../style';
var INFO_QUOTE_LEFT_PADDING = {
  xs: 0,
  md: 56,
  lg: 64,
  xl: 72
};
var INFO_QUOTE_TOP_PADDING = {
  xs: 28,
  sm: 32,
  md: 0
};
var INFO_QUOTE_BOTTOM_MARGIN = {
  xs: 38,
  sm: 44,
  md: 48,
  lg: 56,
  xl: 64
};
var INFO_QUOTE_BOTTOM_LINE_POSITION = {
  xs: -20,
  sm: -24,
  md: -26,
  lg: -30,
  xl: -34
};
var INFO_QUOTE_DIVIDER_WIDTH = 148;
var INFO_QUOTE_DIVIDER_HEIGHT = 3;
var INFO_QUOTE_LEFT_POSITION = {
  xs: -2,
  md: -3,
  lg: -4
};
var INFO_QUOTE_FONT_SIZE = {
  xs: '64px',
  md: '88px',
  lg: '108px',
  xl: '112px'
};
var INFO_QUOTE_LINE_HEIGHT = {
  xs: '44px',
  md: '72px',
  lg: '84px',
  xl: '88px'
};
var INFO_QUOTE_AGENT_BOTTOM_MARGIN = {
  xs: 24,
  sm: 24,
  md: 32,
  lg: 32,
  xl: 40
};
var ContentWrapper = styled.div(_templateObject());
var AgentWrapper = styled.div(_templateObject2());
var ComponentWrapper = styled.div(_templateObject3(), paddingTop(INFO_QUOTE_TOP_PADDING), paddingLeft(INFO_QUOTE_LEFT_PADDING), NIGHTINGALE_BLACK, left(INFO_QUOTE_LEFT_POSITION), largeHeadingStyle, userSelectNoneStyle, fontSize(INFO_QUOTE_FONT_SIZE), lineHeight(INFO_QUOTE_LINE_HEIGHT), AgentWrapper, ContentWrapper, marginTop(INFO_QUOTE_AGENT_BOTTOM_MARGIN));
var QuoteWrapper = styled.div(_templateObject4(), marginBottom(INFO_QUOTE_BOTTOM_MARGIN), getPx(INFO_QUOTE_DIVIDER_WIDTH), getPx(INFO_QUOTE_DIVIDER_HEIGHT), ADVENTURE_GREEN, bottom(INFO_QUOTE_BOTTOM_LINE_POSITION), userSelectNoneStyle);

var InfoQuote = function InfoQuote(_ref) {
  var quoteTitle = _ref.quoteTitle,
      _ref$quoteNoQuotes = _ref.quoteNoQuotes,
      quoteNoQuotes = _ref$quoteNoQuotes === void 0 ? false : _ref$quoteNoQuotes,
      _ref$quoteNoLine = _ref.quoteNoLine,
      quoteNoLine = _ref$quoteNoLine === void 0 ? false : _ref$quoteNoLine,
      quoteAs = _ref.quoteAs,
      quoteFixedHeight = _ref.quoteFixedHeight,
      quoteLines = _ref.quoteLines,
      quoteComponent = _ref.quoteComponent,
      _ref$quoteProps = _ref.quoteProps,
      quoteProps = _ref$quoteProps === void 0 ? EMPTY_PROPS : _ref$quoteProps,
      agent = _ref.agent,
      content = _ref.content,
      props = _objectWithoutPropertiesLoose(_ref, ["quoteTitle", "quoteNoQuotes", "quoteNoLine", "quoteAs", "quoteFixedHeight", "quoteLines", "quoteComponent", "quoteProps", "agent", "content"]);

  return /*#__PURE__*/React.createElement(ComponentWrapper, props, /*#__PURE__*/React.createElement(QuoteWrapper, null, /*#__PURE__*/React.createElement(Quote, _extends({
    as: quoteAs,
    fixedHeight: quoteFixedHeight,
    lines: quoteLines,
    noQuotes: quoteNoQuotes,
    noLine: quoteNoLine,
    component: quoteComponent
  }, quoteProps), quoteTitle)), agent ? /*#__PURE__*/React.createElement(AgentWrapper, null, agent) : null, content ? /*#__PURE__*/React.createElement(ContentWrapper, null, content) : null);
};

export default InfoQuote;